/* eslint-disable react-hooks/exhaustive-deps */
import LoadingContent from 'components/LoadingContent';
import { useFormik } from 'formik';
import React from 'react';
import TopProcessBar from 'screen/selectCollege/TopProcessBar';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import { Container, Form, Spinner, Button } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { useHistory, useLocation } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import SelectInput from 'components/input/SelectInput';
import SearchIcon from '@mui/icons-material/Search';
import TextInput from 'components/input/textInput';
import {
  checkEnableParseJSON,
  fullSuffixOptions,
  occupationOptions,
  tryParseJSON,
} from 'components/helper/helper';
import SelectPhoneCodeInput from 'components/input/SelectPhoneCodeInput';
import TextIconInput from 'components/input/TextIconInput';
import GroupRadioButton from 'components/input/GroupRadioButton';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import SelectSearchInput from 'components/input/SelectSearchInput';
import { Typeahead } from 'react-bootstrap-typeahead';
import collegeServices from 'services/collegeServices';
import { getHousehold, updateHousehold } from 'app/family/familySlice';
import Education from '../parent/components/Education';
import { debounce } from 'lodash';
import YesNoSwitch from 'components/input/YesNoSwitch';
import Residency from '../parent/components/Residency';
import { countryOptions } from 'components/helper/countryPhoneCode';
import CheckboxInput from 'components/input/CheckboxInput';
import Grid from '@mui/joy/Grid';
import { ModalCheckFamilyField } from '../common/ModalCheckMissingField';
import { useFamilyRequiredValidation } from '../common/useFamilyRequiredValidation';
import { PAGE_NAME } from 'constants/common';
import { getAccessToken, getUserId, removeAccessToken, removeUserId } from 'utils/sessionStorage';
import { toggleReviewedAndComplete } from 'services/reviewAndComplete';
import pageStatusService from 'services/pageStatusService';

type Props = {};

const LegalGuardian = (props: Props) => {
  const [loading, setLoading] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const [showModalCheckField, setShowModalCheckField] = React.useState(false);
  const query = new URLSearchParams(useLocation().search);
  const check = query.get('check');
  const { showMissing, validateRequiredFields } = useFamilyRequiredValidation(
    'legal-guardian',
    check,
    () => getModalData(),
    () => setShowModalCheckField(true)
  );
  const dispatch = useAppDispatch();
  const history = useHistory();
  let studentId = getUserId();
  const [currentParentCollege, setCurrentParentCollege] = React.useState<any[]>([]);
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  let searchCtrl = new AbortController();
  const [stateOptions, setStateOptions] = React.useState<any[]>([]);
  const collegeTypeaheadRef = React.createRef<typeof Typeahead>();
  // const location = useLocation();
  
  React.useEffect(() => {
    collegeServices.getState().then((res: any) => {
      const states = res.map((item: any) => {
        return item.descr;
      });
      setStateOptions(states);
    });
  }, []);

  let token = getAccessToken();
  const family = useAppSelector((store) => store.family);
  const formik = useFormik({
    initialValues: {
      prefix: '',
      first_name: '',
      middle_name: '',
      last_name: '',
      former_last_name: '',
      suffix: '',
      step_parent_relationship: '',
      step_parent_email: '',
      country_code: '',
      phone_number: '',
      phone_number_type: '',
      occupation: '',
      other_occupation_detail: '',
      employment_status: '',
      currently_employed_or_retire_from_college: '',
      college_or_university: '',
      current_employer: '',
      education_level: '',
      college_code: '',
      college_state: '',
      college_city: '',

      //#region These fields will copy back from fromItem ///////////////////
      total_number_institutions_attended: 0,
      parent_graduation_college_array: [
        {
          degreesNumber: '',
          degreesReceived1: '',
          graduationYear1: '',
          degreesReceived2: '',
          graduationYear2: '',
          degreesReceived3: '',
          graduationYear3: '',
          degreesReceived4: '',
          graduationYear4: '',
          degreesReceived5: '',
          graduationYear5: '',
          school: {
            ceeb: '',
            fib_code: '',
            name: '',
            school_type: null,
            city: '',
            state: '',
            zip: '',
            country: '',
            csu_name: '',
            uc_name: '',
            cm_name: '',
            match_all: false,
            label: '',
            code: null,
            is_manual: false,
            id: '',
            // old fields :
            //   address_line_1: '',
            //   address_line_2: '',
            //   address_line_3: '',
            province: '',
            state_or_province: '',
            //   zip_code: '',
          } as any,
        },
      ],
      //#endregion

      csu_info: {
        is_give_permission_communicate_to: '',
        is_give_permission_to_receive_information: '',
        authorize_parent_guardian_as_emergency_contact: '',
        isCurrentPermanentResidentOfCalifornia: '',
        isLivedInCaliforniaContinuouslySinceBirth: '',
        whenStayInCaliforniaBegin: '',
        priorCountry: '',
        priorState: '',
        fromWhenToWhenLiveThere: '',
        ToWhenToWhenLiveThere: '',
        stateRegardAsPermanentHome: '',
        parent_address_is: '',
        different_parent_address_country: '',
        different_parent_address_line_1: '',
        different_parent_address_line_2: '',
        different_parent_address_city: '',
        different_parent_address_state: '',
        different_parent_address_province: '',
        different_parent_address_zip_code: '',
        is_authorized_UC_to_share_contact_information: false,
      },
    },
    onSubmit: async (values) => {
      try {
        console.log('run submit');
        const newCollegeArray = formItem.values.parent_graduation_college_array.filter((item) => {
          const noSchoolId = !item?.school?.id;

          const allNull = Object.values(item).every((value) => {
            if (value && typeof value === 'object') {
              return Object.values(value).every((val) => !val);
            }
            return !value;
          });

          const notInCurrentParentCollege = !currentParentCollege.some(
            (currentItem) => currentItem?.school?.name === item?.school?.name
          );
          return noSchoolId && notInCurrentParentCollege && !allNull;
        });
  

        //#region remove priorCountryOption and objectCountries propeties
        let new_csu:any = Object.assign({}, values.csu_info);
        delete new_csu.priorCountryOption;
        delete new_csu.objectCountries;
        //#endregion

        let newValues:any = {
          ...values,
          total_number_institutions_attended: Number(`${formItem.values.total_number_institutions_attended ?? '0'}`),
          parent_graduation_college_array: JSON.stringify(formItem.values.parent_graduation_college_array),
          csu_info: JSON.stringify(new_csu),
        };

        //#region delete old properties
        delete newValues.step_parent_is_married;
        delete newValues.step_parent_type;
        delete newValues.step_parent_is_living;
        //#endregion
        

        let newData = {
          ...family.myHousehold,
          legal_guardian: JSON.stringify(newValues),
          student_id: parseInt(studentId || ''),
        };
        console.log('updateHousehold:  newValues: ', newData);
        await dispatch(updateHousehold(newData));
  
        if (newCollegeArray.length > 0 && formItem.values.is_education_saved) {
          const dataSendmail = {
            student_id: parseInt(studentId || ''),
            parent_name: 'Legal Guardian',
            collegesInfo: newCollegeArray,
          }
          await collegeServices.sendMailNewParentCollege(dataSendmail);
        }
  

      }
      catch(ex){
        console.log('Error:', ex);
      }

    },
  });

  const formItem = useFormik({
    initialValues: {
      total_number_institutions_attended: '0',
      parent_graduation_college_array: [
        {
          degreesNumber: '',
          degreesReceived1: '',
          graduationYear1: '',
          degreesReceived2: '',
          graduationYear2: '',
          degreesReceived3: '',
          graduationYear3: '',
          degreesReceived4: '',
          graduationYear4: '',
          degreesReceived5: '',
          graduationYear5: '',
          school: {
            ceeb: '',
            fib_code: '',
            name: '',
            school_type: null,
            city: '',
            state: '',
            zip: '',
            country: '',
            csu_name: '',
            uc_name: '',
            cm_name: '',
            match_all: false,
            label: '',
            code: null,
            is_manual: false,
            id: '',
            // old fields :
            //   address_line_1: '',
            //   address_line_2: '',
            //   address_line_3: '',
            province: '',
            state_or_province: '',
            //   zip_code: '',
          } as any,
        },
      ],
      is_education_saved: false,
    },
    onSubmit: async (values) => {
      formik.setFieldValue('total_number_institutions_attended', Number(values.total_number_institutions_attended));
      formik.setFieldValue('parent_graduation_college_array', values.parent_graduation_college_array);
    },
  });

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const handleContinue = () => {
    const nextRoute = Object.keys(family.roleFamily).find(
      (key, index) =>
        index > Object.keys(family.roleFamily).indexOf('legalGuardian') &&
        family.roleFamily[key] === true
    );
    formik.handleSubmit();
    // Do not leave the page while required fields are still missing.
    if (!validateRequiredFields()) return;
    history.push(nextRoute ? routers?.[nextRoute]?.path : routers.enrolimentStatus.path);
  };

  const handleCheckMissingFields = () => {
    setShowModalCheckField(true);
  };

  const handleCloseModal = () => {
    setShowModalCheckField(false);
  };

  // Save always keeps the draft (same as auto-save), then reports missing required fields.
  const handleSave = (e?: React.FormEvent<HTMLFormElement>) => {
    e?.preventDefault();
    formik.handleSubmit();
    validateRequiredFields();
  };

  // Prepare data for modal check
  const getModalData = () => {
    return {
      ...formik.values,
      parent_graduation_college_array: formItem.values.parent_graduation_college_array,
    };
  };

  const onReviewdAndComplete = () => {
    // Only allow marking as Reviewed when all required fields are filled.
    if (!reviewedAndComplete && !validateRequiredFields()) return;
    void toggleReviewedAndComplete(PAGE_NAME.LEGAL_GUARDIAN, reviewedAndComplete, setReviewedAndComplete);
  }


  const getDetail = async () => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      formik.resetForm();
      setLoading(true);
      const pageStatus: {
        student_completed: boolean;
      } = await pageStatusService.getPageStatusByPageName(studentId, PAGE_NAME.LEGAL_GUARDIAN);
      if (pageStatus) {
        setReviewedAndComplete(pageStatus.student_completed);
      }
      let res = await dispatch(getHousehold(studentId));
      const dataLoaded: any = checkEnableParseJSON(res.payload?.legal_guardian);
      if (dataLoaded) {
        formik.setValues({
          ...formik.values,
          ...dataLoaded,
          parent_graduation_college_array: tryParseJSON(dataLoaded.parent_graduation_college_array),
          csu_info: {
            ...formik.values.csu_info,
            ...tryParseJSON(dataLoaded.csu_info),
          },
        });

        formItem.resetForm({
          values: {
            ...formItem.values,
            total_number_institutions_attended:
              dataLoaded.total_number_institutions_attended.toString(),
            parent_graduation_college_array: tryParseJSON(
              dataLoaded.parent_graduation_college_array
            ),
          },
        });

        if (dataLoaded.parent_graduation_college_array) {
          setCurrentParentCollege(checkEnableParseJSON(dataLoaded.parent_graduation_college_array));
        }
      }

      setLoading(false);
      formik.setStatus('idle');
    } else {
      handleLogout();
    }
  };
  React.useEffect(() => {
    getDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // Auto save function ==========
  React.useEffect(() => {
    if (!!formik.status) debounceSaving();
  }, [formik.values]);
  const debounceSaving = React.useCallback(
    debounce(() => {
      if (!loading) formik.handleSubmit();
    }, 1500),
    []
  );

  React.useEffect(() => {
    // Handle responsive detection
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // Auto save function ==========
  const [collegeData, setCollegeData] = React.useState([]);

  const handleSearchCollege = async (keyword: string) => {
    if (keyword && keyword.trim().length>0) {
      searchCtrl.abort();
      searchCtrl = new AbortController();
      const res: any = await collegeServices.getCollegeEx({ keyword: keyword.trim() }, searchCtrl);
      const data = res.map((item: any) => ({ ...item, label: item.name, value: item.name }));
      setCollegeData(data);
    }
    else{
      setCollegeData([]);
    }
  };
  const handleChangeItem = (item: any) => {
    formik.setFieldValue('college_code', item?.zip_code);
    formik.setFieldValue('college_state', item?.state);
    formik.setFieldValue('college_city', item?.city);
  };
  return loading ? (
    <LoadingContent />
  ) : (
    <>
      <TopProcessBar
        stepProcess={[
          { title: 'General', percentOnProcess: 25 },
          { title: 'Authorization', percentOnProcess: 50 },
          { title: 'Education', percentOnProcess: 75 },
          { title: 'Residency', percentOnProcess: 98 },
        ]}
        title="Family Information"
        process={1}
        icon={<PeopleAltOutlinedIcon />}
        isMobile={isMobile}
      />
      <Container 
        className={`main-container gm-basic-info-page ${isMobile ? 'p-mobile-2' : ''}`}
        style={{
          paddingLeft: isMobile ? '12px' : undefined,
          paddingRight: isMobile ? '12px' : undefined,
          paddingTop: isMobile ? '60px' : undefined,
          maxWidth: '100vw',
          overflow: 'hidden'
        }}
      >
        <div className={`${isMobile ? 'p-mobile-2' : 'px-4 py-4'} d-flex justify-content-end`}>
          <Button
            variant="primary"
            className={`${isMobile ? 'w-100 py-3' : 'p-2 px-4 mx-2'} gm-btn-check-fields`}
            onClick={handleCheckMissingFields}
            style={{
              fontSize: isMobile ? '16px' : '14px',
              minHeight: isMobile ? '44px' : 'auto',
            }}
          >
            check missing values
          </Button>
        </div>
        <div className={`gm-section-card ${isMobile ? 'p-mobile-2' : 'px-4 py-4'}`}>
          <Form
            style={{ 
              maxWidth: isMobile ? '100%' : '900px',
              width: '100%'
            }}
            onSubmit={handleSave}
            className="gm-form-grid"
          >
            <div id="General" className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
              <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                Legal Guardian
              </span>
            </div>

            <div className="gm-section-card">
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12} md={6}>
                  <SelectInput
                    form={formik}
                    option={[{ value: 'Dr.' }, { value: 'Mr.' }, { value: 'Ms.' }, { value: 'Mrs.' }]}
                    label="Prefix*"
                    onChange={formik.handleChange}
                    name="prefix"
                    values={formik.values.prefix}
                    isMissing={!formik.values.prefix && showMissing}
                    disabled={reviewedAndComplete}
                  />           
                </Grid>

                <Grid xs={12} md={6}>
                  <TextInput
                    label="First/Given name*"
                    name="first_name"
                    values={formik.values.first_name}
                    onChange={formik.handleChange}
                    countText={20}
                    isMissing={!formik.values.first_name && showMissing}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12} md={6}>
                  <TextInput
                    label="Middle Initial"
                    name="middle_name"
                    values={formik.values.middle_name}
                    onChange={formik.handleChange}
                    countText={20}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12} md={6}>
                  <TextInput
                    label="Last Name*"
                    name="last_name"
                    values={formik.values.last_name}
                    onChange={formik.handleChange}
                    countText={20}
                    isMissing={!formik.values.last_name && showMissing}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12} md={6}>
                  <TextInput
                    label="Former Last Name"
                    name="former_last_name"
                    values={formik.values.former_last_name}
                    onChange={formik.handleChange}
                    countText={20}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12} md={6}>
                  <SelectInput
                    form={formik}
                    option={fullSuffixOptions}
                    label="Suffix"
                    name="suffix"
                    values={formik.values.suffix}
                    onChange={formik.handleChange}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12}>
                  <TextInput
                    label="Relationship to you*"
                    name="step_parent_relationship"
                    values={formik.values.step_parent_relationship}
                    onChange={formik.handleChange}
                    countText={50}
                    mdCol={'12'}
                    isMissing={!formik.values.step_parent_relationship && showMissing}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12}>
                  <TextInput
                    label="Email Address *"
                    name="step_parent_email"
                    values={formik.values.step_parent_email}
                    onChange={formik.handleChange}
                    countText={50}
                    mdCol={'12'}
                    isMissing={!formik.values.step_parent_email && showMissing}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12}>
                  <GroupRadioButton
                    mdCol={3}
                    label="Preferred phone*"
                    name="phone_number_type"
                    onChange={formik.handleChange}
                    values={formik.values.phone_number_type}
                    options={[
                      { value: 'Home' },
                      { value: 'Mobile' },
                      { value: 'Work' },
                      { value: 'Other' },
                    ]}
                    isMissing={!formik.values.phone_number_type && showMissing}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12} md={6}>
                  <SelectPhoneCodeInput
                    label="Country Code"
                    name="country_code"
                    onChange={formik.handleChange}
                    values={formik.values.country_code}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12} md={6}>
                  <TextIconInput
                    type="number"
                    icon={<PhoneAndroidIcon />}
                    name="phone_number"
                    onChange={formik.handleChange}
                    values={formik.values.phone_number}
                    label="Phone Number"
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12}>
                  <GroupRadioButton
                  label="Parent Address is*"
                  className="uc-flag mb-5 pt-3 "
                  name="csu_info.parent_address_is"
                  onChange={formik.handleChange}
                  values={formik.values.csu_info?.parent_address_is}
                  options={[
                    { value: 'The same as my home address', mdCol: 4 },
                    { value: 'A different address' },
                    { value: 'Unknown' },
                  ]}
                  isMissing={!formik.values.csu_info?.parent_address_is && showMissing}
                  disabled={reviewedAndComplete}
                  />
                </Grid>
              <div />
              {formik.values.csu_info?.parent_address_is === 'A different address' && (
                <>
                  <Grid xs={12} md={6}>
                    <SelectInput
                        option={countryOptions}
                        label={'Country*'}
                        name={'csu_info.different_parent_address_country'}
                        values={formik.values.csu_info?.different_parent_address_country}
                        onChange={formik.handleChange}
                        isMissing={!formik.values.csu_info?.different_parent_address_country && showMissing}
                        disabled={reviewedAndComplete}
                      />
                  </Grid>

                  <Grid xs={12} md={6}>
                    <TextInput
                      label={'Address Line 1*'}
                      name={'csu_info.different_parent_address_line_1'}
                      values={formik.values.csu_info?.different_parent_address_line_1}
                      onChange={formik.handleChange}
                      countText={36}
                      isMissing={!formik.values.csu_info?.different_parent_address_line_1 && showMissing}
                      disabled={reviewedAndComplete}
                    />
                  </Grid>

                  <Grid xs={12} md={6}>
                    <TextInput
                      label={'Address Line 2'}
                      name={'csu_info.different_parent_address_line_2'}
                      values={formik.values.csu_info?.different_parent_address_line_2}
                      onChange={formik.handleChange}
                      disabled={reviewedAndComplete}
                    />
                  </Grid>

                  <Grid xs={12} md={6}>
                    <TextInput
                      label={'City*'}
                      name={'csu_info.different_parent_address_city'}
                      values={formik.values.csu_info?.different_parent_address_city}
                      onChange={formik.handleChange}
                      countText={25}
                      isMissing={!formik.values.csu_info?.different_parent_address_city && showMissing}
                      disabled={reviewedAndComplete}
                    />         
                  </Grid>                    

                  {formik.values.csu_info?.different_parent_address_country ===
                    'United States of America' ? (
                      <Grid xs={12} md={6}>
                        <SelectInput
                          option={stateOptions}
                          label={'State*'}
                          name={'csu_info.different_parent_address_state'}
                          values={formik.values.csu_info?.different_parent_address_state}
                          onChange={formik.handleChange}
                          isMissing={!formik.values.csu_info?.different_parent_address_state && showMissing}
                          disabled={reviewedAndComplete}
                        />
                      </Grid>

                  ) : (
                    <Grid xs={12} md={6}>
                      <TextInput
                        label={'Province *'}
                        name={'csu_info.different_parent_address_province'}
                        values={formik.values.csu_info?.different_parent_address_province}
                        onChange={formik.handleChange}
                        countText={80}
                        isMissing={!formik.values.csu_info?.different_parent_address_province && showMissing}
                        disabled={reviewedAndComplete}
                      />
                    </Grid>
                  )}

                  <Grid xs={12} md={6}>
                    <TextInput
                      countText={11}
                      label={'Zip Code*'}
                      name={'csu_info.different_parent_address_zip_code'}
                      values={formik.values.csu_info?.different_parent_address_zip_code}
                      onChange={formik.handleChange}
                      isMissing={!formik.values.csu_info?.different_parent_address_zip_code && showMissing}
                      disabled={reviewedAndComplete}
                    />
                  </Grid>
                </>
              )}
              </Grid>
            </div>

            <div className="gm-section-card">
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12}>
                  <div id="Authorization" className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
                    <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                      Authorization
                    </span>
                  </div>
                </Grid>
                <Grid xs={12}>
                  <div  className="text-dart fs-5">Authorization</div>
                </Grid>

                <Grid xs={12}>
                  <YesNoSwitch
                    logo="span-csu-logo"
                    name="csu_info.is_give_permission_communicate_to"
                    values={formik.values.csu_info?.is_give_permission_communicate_to}
                    onChange={formik.handleChange}
                    label="Do you give permission for the admission office to communicate with your Parent/Guardian regarding your application?"
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12}>
                  <YesNoSwitch
                    logo="span-csu-logo"
                    values={formik.values.csu_info?.is_give_permission_to_receive_information}
                    onChange={formik.handleChange}
                    name="csu_info.is_give_permission_to_receive_information"
                    label="Do you give permission for your parent/guardian to receive university communications? These may include new student and housing information, parent activities, volunteer and charitable opportunities, and general campus information."
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12}>
                  <YesNoSwitch
                    className="py-3"
                    logo="span-csu-logo"
                    name="csu_info.authorize_parent_guardian_as_emergency_contact"
                    values={formik.values.csu_info?.authorize_parent_guardian_as_emergency_contact}
                    onChange={formik.handleChange}
                    label="I authorize the use of this parent/guardian information to be used as my emergency contact when I enroll at a CSU."
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12}>
                  <p>Can we share your parent's contact information with UC campuses and programs?</p>
                  <p>
                    If you check this option, your parent may receive information about admissions tips,
                    updates and reminders from UC campuses (even ones you haven't applied to) and
                    outreach programs. They may contact them before or after you've submitted the
                    application.
                  </p>
                  <CheckboxInput
                    values={formik.values.csu_info?.is_authorized_UC_to_share_contact_information}
                    onChange={formik.handleChange}
                    name="csu_info.is_authorized_UC_to_share_contact_information"
                    label="I authorize the University of California to share my parent's contact information."
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12} md={6}>
                  <SelectInput
                    form={formik}
                    option={occupationOptions}
                    logo="span-cm-logo"
                    label="Occupation (former occupation, if retired or deceased)"
                    name="occupation"
                    values={formik.values.occupation}
                    onChange={formik.handleChange}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12}>
                  <GroupRadioButton
                    logo="span-cm-logo"
                    hidden={
                      formik.values.employment_status !== 'Employed' &&
                      formik.values.employment_status !== 'Retired'
                    }
                    label="Is parent currently employed by or retired from a college or university?*"
                    name="currently_employed_or_retire_from_college"
                    values={formik.values.currently_employed_or_retire_from_college}
                    onChange={formik.handleChange}
                    mdCol={12}
                    options={[
                      { value: 'Never employed at a college/university' },
                      { value: 'Currently employed at a college/university' },
                      { value: 'Retired from a college/university' },
                    ]}
                    isMissing={!formik.values.currently_employed_or_retire_from_college && showMissing}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12}>
                  <TextInput
                    logo="span-cm-logo"
                    hidden={formik.values.occupation !== 'Other'}
                    label="Other Occupation Details"
                    name="other_occupation_detail"
                    values={formik.values.other_occupation_detail}
                    onChange={formik.handleChange}
                    countText={50}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12} md={6}>
                  <SelectInput
                    form={formik}
                    logo="span-cm-logo"
                    name="employment_status"
                    values={formik.values.employment_status}
                    option={[
                      { value: 'Employed' },
                      { value: 'Unemployed' },
                      { value: 'Retired' },
                      { value: 'Self-Employed' },
                    ]}
                    label="Employment status*"
                    onChange={formik.handleChange}
                    isMissing={!formik.values.employment_status && showMissing}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12}>
                  <SelectSearchInput
                    logo="span-cm-logo"
                    hidden={
                      !(
                        (formik.values.employment_status === 'Employed' ||
                          formik.values.employment_status === 'Retired') &&
                        formik.values.currently_employed_or_retire_from_college !==
                        'Never employed at a college/university'
                      )
                    }
                    form={formik}
                    values={formik.values.college_or_university}
                    name="college_or_university"
                    label="College/University employer lookup*"
                    option={collegeData ?? []}
                    onSearch={(keyword) => handleSearchCollege(keyword)}
                    onChangeItem={handleChangeItem}
                    inputRef={collegeTypeaheadRef}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

                <Grid xs={12} md={6}>
                  <TextInput
                    logo="span-cm-logo"
                    hidden={
                      !(
                        (formik.values.employment_status === 'Employed' ||
                          formik.values.employment_status === 'Retired') &&
                          formik.values.currently_employed_or_retire_from_college !== 'Currently employed at a college/university'
                      )
                    }
                    label="Name of Current Employer"
                    name="current_employer"
                    countText={40}
                    values={formik.values.current_employer}
                    onChange={formik.handleChange}
                    disabled={reviewedAndComplete}
                  />
                </Grid>

              </Grid>
            </div>

            <div className="gm-section-card">
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12}>
                  <div id="Education" className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
                    <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                      Education
                    </span>
                  </div>
                </Grid>
                <Education 
                  formik={formik} 
                  formItem={formItem} 
                  isMobile={isMobile}
                  check={showMissing}
                  disabled={reviewedAndComplete}
                />
              </Grid>
            </div>

            <div className="gm-section-card">
              <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
                <Grid xs={12}>
                  <div id="Residency" className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
                    <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                      Residency
                    </span>
                  </div>
                </Grid>
                <Residency 
                  formik={formik} 
                  isMobile={isMobile}
                  check={showMissing} 
                  disabled={reviewedAndComplete} 
                />
              </Grid>
            </div>

            <div className={`gm-form-actions border-top ${isMobile ? 'pt-2 mt-3' : 'pt-3 mt-4'} d-flex ${isMobile ? 'flex-column' : 'justify-content-between align-items-center'}`}>
              {/* Icon + Checkbox combo on the left */}
              <div className={`${isMobile ? 'w-100 mb-3' : ''} d-flex justify-content-center`}>
                <div className="d-flex flex-column align-items-center">
                  <div
                    onClick={handleCheckMissingFields}
                    className="d-flex align-items-center cursor-pointer mb-2"
                  >
                    <SearchIcon
                      style={{
                        fontSize: '24px',
                        color: '#6c757d',
                      }}
                    />
                    <span
                      style={{
                        fontSize: '14px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      check missing values
                    </span>
                  </div>

                  <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                    <input
                      type="checkbox"
                      style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid #6c757d',
                        borderRadius: '2px',
                      }}
                      checked={reviewedAndComplete}
                      onClick={onReviewdAndComplete}  
                    />
                    <span
                      style={{
                        fontSize: isMobile ? '14px' : '12px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      Reviewed
                    </span>
                  </div>
                </div>
              </div>

              {/* Save and Continue buttons on the right */}
              <div className={`${isMobile ? 'w-100' : 'col col-md-6'} text-center ${isMobile ? '' : 'text-md-end'}`}>
                <div className={`d-flex ${isMobile ? 'flex-column gap-2' : 'flex-row'} justify-content-center`}>
                  <Button 
                    variant="primary" 
                    type="submit" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5 mx-2'} gm-btn-save`}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    {family.status === 'loading' ? (
                      <Spinner size="sm" animation="border" variant="light" />
                    ) : (
                      'Save'
                    )}
                  </Button>
                  <Button
                    variant="primary"
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} gm-btn-continue`}
                    onClick={() => handleContinue()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>

          </Form>
        </div>
      </Container>

      <ModalCheckFamilyField
        show={showModalCheckField}
        onClose={handleCloseModal}
        data={getModalData()}
        page="legal-guardian"
      />
    </>
  );
};

export default LegalGuardian;
